export const HANDLE_TOKEN = 'HANDLE_TOKEN';
export const HANDLE_AUTH = 'HANDLE_AUTH';
export const HANDLE_USER_LOGIN ="HANDLE_USER_LOGIN"
export const HANDLE_USER_REGISTER ="HANDLE_USER_REGISTER";
export const HANDLE_UPDATE_USER_REGISTER ="HANDLE_UPDATE_USER_REGISTER"
export const HANDLE_APP_INSTALL_CHECK ="HANDLE_APP_INSTALL_CHECK"
export const HANDLE_CHECK_SESSION ="HANDLE_CHECK_SESSION"